export default __webpack_public_path__ + "locales/sl/ChangeUserTypeDialog.json?hash=da40c2bd91f2b6048bff5fea4d6a6278";